import React, { useEffect } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import ThreeDot from '../../images/threeDots.svg'
import Editpen from '../../images/editpen.svg'
import cancelicon from '../../images/cancel.svg'
import { useState } from 'react'
import EarlyCheckin from "../../components/EarlyCheckinModal.js";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseURL } from '../../constants/Api.js'
import RequestCheckAlert from './RequestCheckAlert.js'
function Threedot(props) {

  // console.log("props==============",props.data)
  
  const earlyTimeArray =  JSON.parse(localStorage.getItem("guestWebEarlyCheckin"));
  const [cancelModalOpen,setcancelModalOpen] = useState(false);
  // console.log("earlyTimeArray==============in 3 dits",earlyTimeArray)
  const hotelDetails = JSON.parse(localStorage.getItem("hotelDetailsGuestWeb")) ;
  const bookingParams = {
    appUserId: localStorage.getItem("appUserId"),
    reservationId: localStorage.getItem("reservationId"),
    guestId: localStorage.getItem("guestId"),
    hotelId: localStorage.getItem("hotel-id"),
    hotelDetails: hotelDetails,
  };
  const [earlycheckmodalshow , setearlycheckmodalshow ] = useState(false)
  const navigate = useNavigate();
  async function handleNavigate() {
    props?.checkFunction();
    const response = await props.checkStatus();
    // console.log("response in the three dots",response?.extendStay)

    if(props.name == 'earlyCheckin') {
      if(response.earlyCHeckinEdit === true){
        setearlycheckmodalshow(true);
        console.log("earlyCheckin");
      }
    }else if(props.name === 'extendStay'){
      if(response.extendStayEdit === true){
         navigate('/extend-stay?is_edit=true',{
          state: {
            extendStaydata:props.data
         },
         });
      }
    }else if(props.name === 'roomChange'){
      if(response.roomChangeEdit === true){
        navigate('/room-change?is_edit=true',{
          state: {
            roomChangedata:props.data.comment 
         },
        });
     }
    }else if(props.name == 'pickup'){
        navigate(`/pick-and-drop/${props?.data?.hotelId}`,{
          state: {
             pickanddropdata:props?.data 
          },
        });
      
    }else if(props.name == 'spa'){
      navigate(`/spa-catagory/${props?.data?.hotelId}-${props?.data?.spaId}-SpaId-${props?.data?.spaServiceId}`,{
        state: {
           spadata:props?.data
        },
      });
    }else if(props.name == 'Table_Dining'){
        
        navigate(`/tablereservation-form`,{
          state: props?.data
        });
      
    }
  }

  async function handleCancel() {
    let  endpoint ="";
    let data = "";
    let method = ""
    console.log("props.name========================",props.name)
    props?.checkFunction();
    const response = await props.checkStatus();
    if(props.name == 'Table_Dining'){
      endpoint = "tableBookingCancel"; 
      method = "put"

      data = JSON.stringify({
        "id": props?.data.id
      });
     
    }else if(props.name == 'pickup'){
        endpoint = "cancelChauffeur"
        method = "post"
        data = JSON.stringify({
          "id": props?.data.id
        });
        // console.log("pick canceledddddd")
        
    }else if(props.name == 'spa'){
        endpoint = "spaBookingCancel"
        method = "post"
        data = JSON.stringify({
          "spaBookingId": props?.data.id
        });
        // console.log("spa canceledddddd")
    }else if(props.name == 'houseKeeping'){
      endpoint = "service"
      method = "put"
      data = JSON.stringify({
        "serviceId": props?.data.id
      });
    }else if(props.name == 'wakeUp'){
      endpoint = "cancelWakeUp"
      method = "post"
      data = JSON.stringify({
        "id": props?.data.id
      });
    }
     console.log("endpoint,method,data==============",endpoint,method,data)
    updateData(endpoint,method,data);
  }


const updateData = async (endpoint,method,data) => {
  try {
    const response = await axios({
      method: method,
      url: `${baseURL}/api/${endpoint}`, 
      data: data, 
      headers: {
          "Content-Type": "application/json",
      },
    });
      if(response.data.success === true){
        // console.log("Update Successful:", response.data.success);
        const parentResponse = props.onDataUpdate(props?.data.id);
        // console.log("parentResponse=====================",parentResponse);
        return parentResponse ;
      }else{
        if(response.data.success === false){
          setcancelModalOpen(true);
        }
        console.log("Update failed in the threedot:", response);
      }
  } catch (error) {
      // console.error("Error updating data:", error);
  }
};
  return (
    <div className=" w-56 text-right">
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className="inline-flex justify-center  text-sm font-medium text-white">
           <img src={ThreeDot} alt='' />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-2 top-5 mt-2 w-[83px] origin-top-right divide-y divide-gray-100 rounded-md bg-white/90 shadow-lg ring-1 ring-black/5 focus:outline-none">
            <div className="px-1 py-0 t">
              <Menu.Item>
                {({ active }) => (
                  <>
                  {
                    props.name == 'houseKeeping'  || props.name == 'wakeUp' ?  " " : 
                  <button
                    className='text-[rgb(98,98,98)] 
                     group flex w-full items-center justify-start rounded-md text-[12px] font-[500] px-1 py-2 text-sm'  onClick={handleNavigate}
                  >
                    <img className='w-[12px] mr-1' src={Editpen} alt=''/>
                    Edit
                  </button>
                  }
                  {(props.name == 'pickup' || props.name =='Table_Dining'  || props.name =='spa' || props.name == 'houseKeeping' || props.name == 'wakeUp') &&
                    <>
                      <hr className='w-[100%] ' style={{backgroundColor:'#b9b6b6', height:'1px'}}></hr>
                      <button className='text-[rgb(98,98,98)] group flex w-full items-center  justify-start rounded-md text-[12px] font-[500] px-1 py-2 text-sm'  onClick={handleCancel} >
                        <img className='h-[15px] mr-1' src={cancelicon} alt=''/>Cancel
                      </button>
                    </>
                  }
                </>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
  {earlycheckmodalshow && 
      <EarlyCheckin
              bookingParams={bookingParams}
              earlyTimeArray={earlyTimeArray}
              hide={() => setearlycheckmodalshow(false)}
              is_editStatus = {true}
            />
  }
  {
    cancelModalOpen && <RequestCheckAlert heading={"Once accepted bookings can not be cancelled"} 
         onClose={() => {
          setcancelModalOpen(false); 
          window.location.reload();  
        }}/>
  }
    </div>
  )
}

export default Threedot
